import { TranslationsContext } from '@teliaee/telia-translate';
import { Container, Grid, GridColumn, Heading, Separator, Spinner, Text, Section } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../stores/RoamingStore';
import RoamingCountryCard from './countrycard/RoamingCountryCard';
import SelectedOperator from './operators/SelectedOperator';
import RoamingCountrySearch from './RoamingCountrySearch';
import RoamingSpecialAndEmergencyTable from './specialnumbers/RoamingSpecialAndEmergencyTable';

interface RoamingProps {
  roamingStore?: RoamingStore;
}

@observer
class Roaming extends React.Component<RoamingProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public componentDidMount() {
    this.props.roamingStore.subscribe();
  }

  public componentWillUnmount() {
    this.props.roamingStore.unsubscribe();
  }

  public render() {
    const translate = this.context.translate;
    const { roamingStore } = this.props;
    if (roamingStore.isCountriesFetching()) {
      return <Spinner />;
    }
    return (
      <Section isFull>
        <Container>
          <Text className="text-center">
            <Heading element="h1" className="h2">
              {translate('roaming.main.header')}
            </Heading>
            <p className="h4">{translate('roaming.sub.header')}</p>
            <Separator spacing="small" color="invisible" />
            <Grid align={['center-xs']}>
              <GridColumn width={['md-6']}>
                <RoamingCountrySearch />
              </GridColumn>
            </Grid>
          </Text>
        </Container>
        <div id="country-card">
          <RoamingCountryCard />
        </div>
        <Container>
          <div id="operators">
            <SelectedOperator />
          </div>
        </Container>
        <Separator spacing="medium" color="invisible" />
        <Container>
          <div id="special-numbers">
            <RoamingSpecialAndEmergencyTable />
          </div>
        </Container>
      </Section>
    );
  }
}

export default inject('roamingStore')(Roaming);
